import React, { useEffect, useRef, useState } from 'react';
import './style.scss';
import '../style.scss';
import dropDownIcon from "assets/imgs/QrCodeMyVNPT/drop-down-icon.png";
import vietQr from "assets/imgs/QrCodeMyVNPT/vietQr.png";
import napas247 from "assets/imgs/QrCodeMyVNPT/napas247.png";
import vnptMomey from "assets/imgs/QrCodeMyVNPT/vnpt-momey.png";
import qrBlurry from "assets/imgs/QrCodeMyVNPT/qr-blurry.jpg";
import PayQrCode from '../PayQrCode/PayQrCode';
import PaymentInfo from '../PaymentInfo/PaymentInfo';
import { QRCodeCanvas  } from 'qrcode.react';
import UserGuide from '../UserGuide/UserGuide';
import { ACTION_IR_REGISTER, DEVICE, formatPhoneNumber, formatVND, INFO_CREATE_TRANS, TRANSACTION_STATUS } from '../constant/contanst';
import { QrCodeMyVNPTService } from '../services/QrCodeMyVNPTService';
import { MAX_COUNT_CHECK_TRANS_STATUS_QR_CODE_MYVNPT, QR_CODE_MYVNPT_DEEPLINK_PACKAGE_DETAIL, TIMER_CHECK_TRANS_STATUS_QR_CODE_MYVNPT } from 'global/environment';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Input, Modal } from 'antd';
import ModalNoti from '../component/ModalNoti/ModalNoti';
import ButtonRoaming from '../component/ButtonRoaming/ButtonRoaming';
import vietinBankIcon from "assets/imgs/QrCodeMyVNPT/vietin-icon.png";
import vcbankIcon from "assets/imgs/QrCodeMyVNPT/vcbank-icon.png";
import agribankIcon from "assets/imgs/QrCodeMyVNPT/agribank-icon.png";
import bidvIcon from "assets/imgs/QrCodeMyVNPT/bidv-icon.png";
import { setDataQueryTransactionInfo } from 'store/action/qrCodeAction';
import { useDispatch } from 'react-redux';
import { cjmEventButtonClicked, cjmEventComponentDisplayed, cjmEventScreenDisplayed } from 'utils/providers/cjmHelper';

const QrCode = ({ setStep, data, setData, packageSelected, countryName, token, setDataTransactionParent }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isModalInfo, setIsModalInfo] = useState(false);
  const [isPayQrCode, setIsPayQrCode] = useState(false);
  const [qrData, setQrData] = useState();
  const [isModalUserGuide, setIsModalUserGuide] = useState(false);
  const [device, setDevice] = useState("");
  const [dataTransaction, setDataTransaction] = useState();
  const [countCheckTranStatus, setCountCheckTranStatus] = useState(0);
  const [isErrorModalVisible, setIsErrorModalVisible] = useState(false);
  const [isModalOTP, setIsModalOTP] = useState(false);
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [isModalNotiIr, setIsModalNotiIr] = useState(false);
  const [messageNotiIr, setMessageNotiIr] = useState("");
  const [btnType, setBtnType] = useState("");
  const [isNotiTrans, setIsNotiTrans] = useState(false);
  const [messageNotiTrans, setMessageNotiTrans] = useState("");
  const [qrBase64, setQrBase64] = useState("");
  const [timerOTP, setTimerOTP] = useState(0);
  const [isButtonRetry, setIsButtonRetry] = useState(true);
  const [listBanks, setListBanks] = useState([]);
  
  const hotPromotion = packageSelected?.hotPromotion ? JSON.parse(packageSelected?.hotPromotion) : [];
  
  const qrRef = useRef(null);
  const timerRef = useRef(null);
  
  useEffect(() => {
    cjmEventComponentDisplayed("myvnpt_web", "roaming_package_QR", "roaming_QR", packageSelected?.packageName)
    const userAgent = window.navigator.userAgent.toLowerCase();
    console.log("User Agent:", userAgent);
    if (userAgent.includes("iphone") || userAgent.includes("ipad")) {
      setDevice(DEVICE.IOS)
    } else if (userAgent.includes("android")) {
      setDevice(DEVICE.ANDROID)
    } else {
      setDevice(DEVICE.OTHER)
      console.log("This feature is only supported on iOS and Android devices.");
    }
  }, []);
  
  useEffect(() => {
    if (qrRef.current) {
      const canvas = qrRef.current.querySelector("canvas");
      if (canvas) {
        setQrBase64(canvas.toDataURL("image/png"));
      }
    }
  }, [qrData]);

  useEffect(() => {
    let interval;
    if (timerOTP > 0 && isErrorModalVisible) {
      interval = setInterval(() => {
        setTimerOTP((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timerOTP, isErrorModalVisible]);

  useEffect(() => {
    if(data?.result?.irCheckActive === 0) {
      handleSendOTP(data?.result?.msisdn);
    }
    
    if(data?.result?.irCheckActive === 1) {
      handleCreateTransaction({
        amount: packageSelected?.price,
        bankCode: INFO_CREATE_TRANS.BANK_CODE,
        currencyCode: INFO_CREATE_TRANS.CURRENCY_CODE,
        type: INFO_CREATE_TRANS.TYPE,
        bankType: INFO_CREATE_TRANS.BANK_TYPE,
        paymentCode: packageSelected?.packageId,
        serviceType: INFO_CREATE_TRANS.SERVICE_TYPE,
        session: data?.token,
        msisdn: data?.result?.msisdn
      })
    }
  }, [data?.result?.irCheckActive]);

  useEffect(() => {
    if(dataTransaction) {
      CheckTranStatus();
    }
    return () => clearInterval();
  }, [dataTransaction]);

  const CheckTranStatus = async () => {
    const interval = setInterval(() => {
      setCountCheckTranStatus((prevCount) => {
        if (prevCount >= Number(MAX_COUNT_CHECK_TRANS_STATUS_QR_CODE_MYVNPT)) {
          clearInterval(interval);
          return prevCount;
        }
        checkQrTransactionInfo({
          session: data?.token,
          msisdn: data?.result?.msisdn,
          transactionId: dataTransaction?.transactionId
        })
        return prevCount + 1;
      });
    }, Number(TIMER_CHECK_TRANS_STATUS_QR_CODE_MYVNPT));

    return () => clearInterval(interval);
  }

  const handleCreateTransaction = async (payload) => {
    try {
      await QrCodeMyVNPTService.createTransaction(payload, res => {
        if (res?.errorCode === "0") {
          setDataTransaction(res?.result);
          setDataTransactionParent(res?.result);
          getQrInfo({
            msisdn: payload?.msisdn,
            session: payload?.session,
            orderId: res?.result?.transactionId
          });
        } else {
          setIsNotiTrans(true);
          setMessageNotiTrans(res?.message);
        }
      })
    } catch (error) {
      console.log(error);
    }
  };

  const getQrInfo = async (payload) => {
    try {
      await QrCodeMyVNPTService.getQR(payload, res => {
        if (res?.errorCode === "0") {
          setQrData(res?.result);
          cjmEventScreenDisplayed("myvnpt_web", "roaming_package_QR", packageSelected?.packageName)
          setListBanks(res?.extraData);
        } else {
          setIsNotiTrans(true);
          setMessageNotiTrans(res?.message);
        }
      })
    } catch (error) {
      console.log(error);
    }
  };

  const checkQrTransactionInfo = async (payload) => {
    try {
      await QrCodeMyVNPTService.queryTransactionInfo(payload, res => {
        if (res?.transactionStatus == TRANSACTION_STATUS.SUCCESS) {
          sessionStorage.setItem('dataQueryTransactionInfo', JSON.stringify(res))
          const encodedToken = encodeURIComponent(token);
          history.push('/thanhtoan/roaming/success?token=' + encodedToken);
        } else if (res?.transactionStatus == TRANSACTION_STATUS.FAIL) {
          sessionStorage.setItem('dataQueryTransactionInfo', JSON.stringify(res))
          const encodedToken = encodeURIComponent(token);
          history.push('/thanhtoan/roaming/fail?token=' + encodedToken);
        } else if (res?.transactionStatus == TRANSACTION_STATUS.TIMEOUT) {
          //Timeout
        }
      })
    } catch (error) {
      console.log(error);
    }
  };
  
  const showErrorModal = (message) => {
    setError(message);
    setIsErrorModalVisible(true);
  };

  const closeErrorModal = () => {
    setIsErrorModalVisible(false);
    setError('');
  };

  const handleSendOTP = (msisdn) => {
    let payload = {
      tinh_id: null,
      otp_service: "ir_register",
      msisdn
    };
    QrCodeMyVNPTService.sendOtp(payload, 
      (response) => {
        if (response.error_code === "0") {
          setIsModalOTP(true);
          setIsButtonRetry(true)
        } else if (response.error_code == "send_sms_nok") {
          showErrorModal(response.message)
          setTimerOTP(60);
          setIsButtonRetry(false)
        } else if (response.error_code == "send_sms_nok_limit_n") {
          showErrorModal(response.message)
          setIsButtonRetry(false)
          setTimerOTP(300);
        }
      }, 
      (error) => {
        setError("Có lỗi xảy ra khi gửi OTP.");
      }
    ); 
  };

  const handleOTP = () => {
    cjmEventButtonClicked("myvnpt_web", "roaming_package_list", "otp_confirm")
    if (otp?.length !== 6) return;
    const payload = {
      session: data?.token,
      otpValue: otp,
      msisdn: data?.result?.msisdn,
      action: ACTION_IR_REGISTER.ACTIVE
    }
    QrCodeMyVNPTService.irRegister(payload,
      (response) => {
        if (response?.errorCode === "0") {
          getPackageInfo({
            encryptedToken: token,
          })
        } else if(response?.errorCode === "550") {
          showErrorModal(response?.message);
          setIsButtonRetry(true)
          setTimerOTP(0)
          setOtp("")
        } else if(response?.errorCode === "539") {
          showErrorModal(response?.message);
          setIsButtonRetry(false)
          setTimerOTP(0)
          setOtp("")
        } else if(response?.errorCode === "551" || response?.errorCode === "552") {
          showErrorModal(response?.message);
          setIsButtonRetry(false)
          setTimerOTP(300)
          setOtp("")
        } else {
          showErrorModal(response.message);
          setIsButtonRetry(true)
          setTimerOTP(0)
          setOtp("")
        }
      }, 
      (error) => {
        showErrorModal("Có lỗi xảy ra khi gọi API.");
        setIsButtonRetry(false)
        setOtp("")
      }
    );
    setIsModalOTP(false);
    setOtp("")
  };

  const getPackageInfo = async (payload) => {
    try {
      await QrCodeMyVNPTService.getPackageInfo(payload, res => {
        if (res?.errorCode === "0") {
          setData(res);
        } 
      })
    } catch (error) {
      console.log(error);
    }
  };
  
  const handleChange = (e) => {
    const value = e.target.value;
    if (!/^\d*$/.test(value)) {
      setError("Bạn phải nhập OTP là dạng số");
      return;
    }
    if (value?.length > 6) return;
    setError("");
    setOtp(value);
  };

  const handleInActiveIrRegister = async () => {
    let payload = {
      session: data?.token,
      msisdn: data?.result?.msisdn,
      action: ACTION_IR_REGISTER.IN_ACTIVE
    }
    try {
      await QrCodeMyVNPTService.irRegister(payload, res => {
        setIsModalNotiIr(true);
        setMessageNotiIr(res?.message);
        if(res?.errorCode == "0") {
          setBtnType(1);
        } else if(res?.errorCode == "403") {
          setBtnType(2);
        } else {
          setBtnType(3);
        }
      })
    } catch (error) {
      console.log(error);
    }
  };

  const handleActiveIrRegister = async () => {
    const payload = {
      session: data?.token,
      otpValue: otp,
      msisdn: data?.result?.msisdn,
      action: ACTION_IR_REGISTER.ACTIVE
    }
    QrCodeMyVNPTService.irRegister(payload,
      (response) => {
        if (response.errorCode === "0") {
          getPackageInfo({
            encryptedToken: token,
          })
          setOtp("")
        } else {
          setError(`Đăng ký OTP thất bại: ${response.message}`);
          showErrorModal(response.message);
          setOtp("")
        }
      }, 
      (error) => {
        console.error("Có lỗi khi gọi API irRegister:", error);
        setError("Có lỗi xảy ra khi gọi API. Vui lòng thử lại.");
        showErrorModal("Có lỗi xảy ra khi gọi API.");
        setOtp("") 
      }
    );
  };

  const handleOnOffIr = () => {
    if(btnType === 1) {
      setBtnType(null)
      setIsModalNotiIr(false);
      setIsModalOTP(true);
      handleSendOTP(data?.result?.msisdn);
    } else if(btnType === 2) {
      handleInActiveIrRegister();
    }
  }

  const startPress = () => {
    if(device === DEVICE.IOS) {
      timerRef.current = setTimeout(() => {
        console.log("hold image");
        cjmEventButtonClicked("myvnpt_web", "roaming_package_QR", "qr_code");
      }, 500);
    }
  };

  const cancelPress = () => {
    clearTimeout(timerRef.current);
  };

  return (
    <div id="qr-code">
      <div className="qr-code__content">
        <div className="qr-code__content--title">Chọn gói cước Quốc tế</div>
        <div className="qr-code__info">
          <div className="qr-code__info-detail">
            <div className="qr-code__info--item">
              <div className="info-txt-normal">Số thuê bao</div>
              <div className="info-txt-bold txt-country">
                {formatPhoneNumber(data?.result?.msisdn)}
              </div>
            </div> 
            <div className="qr-code__info--item">
              <div className="info-txt-normal">Gói cước</div>
              <div className="info-txt-bold">{packageSelected?.packageName}</div>
            </div>
            <div className="qr-code__info--item">
              <div className="info-txt-normal">Giá tiền</div>
              <div className="info-txt-bold">{formatVND(packageSelected?.price)}/ {packageSelected?.cycleDesc}</div>
            </div>
            {/* {
              hotPromotion?.map((e, i) => (
                <div key={i} className="qr-code__info--item">
                  <div className="info-txt-normal">{e.key}</div>
                  <div className="info-txt-bold">{e.value}</div>
                </div>
              ))
            } */}
          </div>
          {
            dataTransaction && (
              <div className="qr-code__info--icon" onClick={() => {
                setIsModalInfo(true)
                cjmEventButtonClicked("myvnpt_web", "roaming_package_QR", "package_detail")
              }}>
                <img src={dropDownIcon} alt="" />
              </div>
            )
          }
        </div>

        <div className="qr-code__frame">
          <div className="qr-code__vietQr">
            <img src={vietQr} alt="vietQr" />
          </div>
          <div className="qr-code__img" ref={qrRef}>
            {
              qrData 
              ? (
                <>
                  <QRCodeCanvas size={148} value={qrData} style={{display: qrBase64 ? "none" : "block"}}/>
                  <img
                    onMouseDown={startPress}
                    onTouchStart={startPress}
                    onMouseUp={cancelPress}
                    onMouseLeave={cancelPress}
                    onTouchEnd={cancelPress}
                    src={qrBase64}
                    alt="QR Code"
                  /> 
                </>
              )
              : <img height={148} width={148} src={qrBlurry} alt="" />
            }
          </div>
          <div className="qr-code__group-img">
            <img className="img-napas247" src={napas247} alt="" />
            <img className="img-vnpt-money" src={vnptMomey} alt="" />
          </div>
        </div>
        <div className="qr-code__amount">{dataTransaction ? formatVND(dataTransaction?.finalAmount) : ""}</div>
        {
          data?.result?.hasPromotion === 'YES' &&
          <div className="qr-code-coupon__wrap">
            <div className="qr-code-coupon__left">
              <div className="qr-code-coupon__discount">{data?.result?.cashbackPercentageValue}%</div>
              <div className="qr-code-coupon__info">
                <div className="coupon__info-txt-bold">Hoàn ngay {data?.result?.cashbackPercentageValue}%</div>
                <div className="coupon__info-txt-normal">Khi mua trên My VNPT</div>
              </div>
            </div>
            <div className="qr-code-coupon__right">
              <a
                className="qr-code-coupon__button"
                onClick={() => {
                  console.log("Voucher clicked")
                  cjmEventButtonClicked("myvnpt_web", "roaming_package_QR", "voucher_used")
                }}
                href={`${QR_CODE_MYVNPT_DEEPLINK_PACKAGE_DETAIL}&packageCode=${packageSelected?.packageCode}`}
              >
                Sử dụng
              </a>
              <div className="qr-code-coupon__border"></div>
            </div>
          </div>
        }

        <div className="qr-code__grp-btn">
          <ButtonRoaming className="normal" onClick={handleInActiveIrRegister}>Tắt chuyển vùng</ButtonRoaming>
          <ButtonRoaming className="success" onClick={() => {
            setIsPayQrCode(true)
            cjmEventButtonClicked("myvnpt_web", "roaming_package_QR", "qr_pay")
          }}>Thanh toán</ButtonRoaming>
        </div>
        <div className="qr-code__note">Lưu ý: Để tránh phát sinh cước chuyển vùng ngoài ý muốn, quý khách cần tắt chuyển vùng nếu không thanh toán hoặc thanh toán thất bại.</div>
        <div className="qr-code--footer">
          <div className="qr-code--footer-txt">Thanh toán qua QR với tất cả ngân hàng và ví</div>
          <div className="qr-code--footer-bank">
            <img src={vcbankIcon} alt="vcbankIcon" />
            <img src={agribankIcon} alt="momoIcon" />
            <img src={bidvIcon} alt="zalopayIcon" />
            <img src={vietinBankIcon} alt="vietinBankIcon" />
            <span>+36</span>
          </div>
          <div className="qr-code__guide-txt" onClick={() => setIsModalUserGuide(true)}>Hướng dẫn thanh toán</div>
        </div>
      </div>

      <PaymentInfo countryName={countryName} dataTransaction={dataTransaction} packageSelected={packageSelected} msisdn={data?.result?.msisdn} isModal={isModalInfo} setIsModal={setIsModalInfo} />

      <PayQrCode 
        isModal={isPayQrCode} 
        onClick={() => {
          setIsPayQrCode(false)
        }}
        setStep={setStep}
        qrData={qrData}
        qrBase64={qrBase64}
        device={device}
        listBanks={listBanks}
      />

      <UserGuide device={device} isModal={isModalUserGuide} setIsModal={setIsModalUserGuide} />

      <Modal
        className="qr-code__modal-custom"
        title={null}
        footer={null}
        closable={null}
        maskClosable={false}
        open={isModalOTP}
        onOk={() => setIsModalOTP(true)}
        onCancel={() => setIsModalOTP(false)}
      >
        <div className="roaming-package-modal-otp">
          <div className="modal-otp-title">Bật chuyển vùng dữ liệu</div>
          <div className="modal-otp-txt">
            Để đăng ký, quý khách cần bật chuyển vùng dữ liệu. Vui lòng nhập OTP được gửi đến số điện thoại 
            <span> {data?.result?.msisdn ? (data?.result?.msisdn.slice(0, 2) === '84' ? `0${data?.result?.msisdn?.slice(2)}` : data?.result?.msisdn) : ''} </span> 
            để bật chuyển vùng
          </div>
          <div className="modal-otp-txt">Lưu ý: Quý khách cần tắt chuyển vùng dữ liệu nếu không còn muốn đăng ký</div>
          <div>
            <Input
              className="modal-otp-input qr-code__input-custom"
              placeholder="Nhập mã OTP"
              value={otp}
              onChange={handleChange}
              maxLength={6}
            />
            {error && <div className="error-message">{error}</div>}
          </div>
          <button
            className="qr-code__btn-custom"
            onClick={handleOTP}
            disabled={otp?.length !== 6}
          >
            Tiếp tục
          </button>
        </div>
      </Modal>

      <Modal
        className="qr-code__modal-custom"
        title={null}
        maskClosable={false}
        footer={null}
        closable={null}
        open={isErrorModalVisible}
        onCancel={() => closeErrorModal()}
      >
        <div className="roaming-package-modal-otp">
          <div className="modal-otp-title">Thông báo</div>
          <div className="modal-otp-txt">{error}</div>
          <div className='group-btn'>
            {
              isButtonRetry && <button
                className="qr-code__btn-custom normal"
                key="retry"
                onClick={() => {
                  closeErrorModal();
                  setIsModalOTP(true)
                  cjmEventButtonClicked("myvnpt_web", "roaming_package_list", "otp_cancel")
                }}
              >
                Nhập lại
              </button>
            }
            <button
              key="resendOtp"
              onClick={() => {
                closeErrorModal();
                handleSendOTP(data?.result?.msisdn);
                cjmEventButtonClicked("myvnpt_web", "roaming_package_list", "otp_resend")
              }}
              className={`qr-code__btn-custom`}
              disabled={timerOTP > 0}
            >
              Gửi lại OTP{' '}
              {timerOTP > 0 && <span id="timer"> ({timerOTP}s)</span>}
            </button>
          </div>
        </div>
      </Modal>
      <ModalNoti
        open={isModalNotiIr}
        message={messageNotiIr}
        maskClosable={false}
        closable={false}
        btnText={btnType === 1 ? "Bật chuyển vùng" : btnType === 2 ? "Nhập lại" : ""}
        onClick={handleOnOffIr}
      />
      <ModalNoti
        maskClosable={false}
        open={isNotiTrans}
        message={messageNotiTrans}
        closable={false}
      />
    </div>
  );
}

export default React.memo(QrCode);
